var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.memberIncreases),function(memberIncrease,key){return _c('div',{key:key},[(memberIncrease != '')?_c('bar-chart',{attrs:{"bar-data":memberIncrease}}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }